var r = /* @__PURE__ */ ((s) => (s[s.EMPORIUM = 0] = "EMPORIUM", s[s.INVENTORY = 1] = "INVENTORY", s[s.OTHERS_INVENTORY = 2] = "OTHERS_INVENTORY", s[s.FAVORITE = 3] = "FAVORITE", s[s.POPUP_SELECT_INVENTORY = 4] = "POPUP_SELECT_INVENTORY", s))(r || {}), o = /* @__PURE__ */ ((s) => (s[s.NoForTypeMismatch = 0] = "NoForTypeMismatch", s[s.NoForTierNotEnough = 1] = "NoForTierNotEnough", s[s.NoForOrbitNotEmpty = 2] = "NoForOrbitNotEmpty", s[s.NoForOrbitLimitTooLow = 3] = "NoForOrbitLimitTooLow", s[s.NoForMissingData = 4] = "NoForMissingData", s[s.Changable = 5] = "Changable", s))(o || {}), i = /* @__PURE__ */ ((s) => (s[s.Korea = 0] = "Korea", s[s.Slavic = 1] = "Slavic", s[s.Egypt = 2] = "Egypt", s[s.Babylon = 3] = "Babylon", s[s.Shinto = 4] = "Shinto", s[s.Norse = 5] = "Norse", s[s.SEA2 = 6] = "SEA2", s[s.Latam = 7] = "Latam", s[s.Tao = 8] = "Tao", s[s.Hindu = 9] = "Hindu", s[s.Greek = 10] = "Greek", s[s.AxisMundi = 11] = "AxisMundi", s[s.ChaosSMBH = 12] = "ChaosSMBH", s[s.Wandering = 13] = "Wandering", s))(i || {}), n = /* @__PURE__ */ ((s) => (s[s.Major = 0] = "Major", s[s.Minor = 1] = "Minor", s[s.None = 2] = "None", s))(n || {}), c = /* @__PURE__ */ ((s) => (s[s.SunSlot = 0] = "SunSlot", s[s.AsteroidBeltSlot = 1] = "AsteroidBeltSlot", s[s.KuiperBeltSlot = 2] = "KuiperBeltSlot", s[s.CometSlot = 3] = "CometSlot", s[s.SupernovaSlot = 4] = "SupernovaSlot", s))(c || {}), u = /* @__PURE__ */ ((s) => (s[s.NonePermanentSupernova = 0] = "NonePermanentSupernova", s[s.HavePermanentSupernova = 1] = "HavePermanentSupernova", s))(u || {}), N = /* @__PURE__ */ ((s) => (s[s.None = 0] = "None", s[s.BlackHole = 1] = "BlackHole", s[s.DarkNebula = 2] = "DarkNebula", s))(N || {}), d = /* @__PURE__ */ ((s) => (s.StarIdAsc = "IDAsc", s.StarIdDesc = "IDDesc", s.PriceAsc = "PriceAsc", s.PriceDesc = "PriceDesc", s.ListAtDesc = "ListingTimeDesc", s.UpdateAtDesc = "UpdateAtDesc", s.ConstellationDigitAsc = "ConstellationDigitAsc", s))(d || {}), _ = /* @__PURE__ */ ((s) => (s.Enable = "Enable", s.ComingSoon = "ComingSoon", s))(_ || {}), m = /* @__PURE__ */ ((s) => (s[s.Buff = 0] = "Buff", s[s.Text = 1] = "Text", s[s.Slot = 2] = "Slot", s))(m || {}), e = /* @__PURE__ */ ((s) => (s[s.Gassy = 0] = "Gassy", s[s.Thunderbolt = 1] = "Thunderbolt", s[s.Flame = 2] = "Flame", s[s.Sparkling = 3] = "Sparkling", s[s.None = 4] = "None", s))(e || {}), v = /* @__PURE__ */ ((s) => (s.Attach = "attach", s.Detach = "detach", s))(v || {}), A = /* @__PURE__ */ ((s) => (s.celestial = "hasCelestialObject", s.ultranova = "hasPermanentNova", s))(A || {});
const P = [
  {
    id: 0,
    nameId: "list.sort_price_asc",
    value: "PriceAsc"
    /* PriceAsc */
  },
  {
    id: 1,
    nameId: "list.sort_price_desc",
    value: "PriceDesc"
    /* PriceDesc */
  },
  {
    id: 2,
    nameId: "list.sort_id_asc",
    value: "IDAsc"
    /* StarIdAsc */
  },
  {
    id: 3,
    nameId: "list.sort_id_desc",
    value: "IDDesc"
    /* StarIdDesc */
  },
  {
    id: 4,
    // latest
    nameId: "list.sort_updated_at_desc",
    value: "UpdateAtDesc"
    /* UpdateAtDesc */
  }
], E = [
  {
    id: 0,
    nameId: "list.sort_price_asc",
    value: "PriceAsc"
    /* PriceAsc */
  },
  {
    id: 1,
    nameId: "list.sort_price_desc",
    value: "PriceDesc"
    /* PriceDesc */
  },
  {
    id: 2,
    nameId: "list.sort_id_asc",
    value: "IDAsc"
    /* StarIdAsc */
  },
  {
    id: 3,
    nameId: "list.sort_id_desc",
    value: "IDDesc"
    /* StarIdDesc */
  },
  {
    id: 4,
    // latest
    nameId: "list.sort_list_at_desc",
    value: "ListingTimeDesc"
    /* ListAtDesc */
  }
], R = [
  0,
  1,
  3,
  2,
  4
  /* SupernovaSlot */
], F = [
  2,
  4
  /* SupernovaSlot */
], H = 1e4, O = "-";
export {
  N as CelestialObjectType,
  n as ConstellationTypeID,
  O as EMPTY_STAR_INFO,
  i as GalaxyID,
  c as OrbitalSlotType,
  u as PermanentSupernovaType,
  H as RELATED_STAR_AUTO_SLIDE_DURATION,
  o as SlotChangableState,
  v as StarAttachGodiverseAction,
  e as StarCoreEffectType,
  E as StarEmporiumSortItems,
  m as StarExplainType,
  r as StarListMode,
  P as StarNormalSortItems,
  R as StarSlotDisplayOrder,
  F as StarSlotHalfDisplayTypes,
  d as StarSortBy,
  A as StarSpecialFilter,
  _ as StarStatus
};
//# sourceMappingURL=star.js.map
